import React, { useEffect, useState } from "react";
import { Dropdown, IDropdownOption } from "@fluentui/react";
import { SubjectApi } from "../../api-clients/api";
import { getApiUrl } from "../../api-clients";

interface IProps {
  onChange: (
    event: React.FormEvent<HTMLDivElement>,
    option?: IDropdownOption,
    index?: number
  ) => void;
  selectedKey?: string | number | null;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
}
export default function SubjectsDropdown(props: IProps) {
  const [subjectApi] = useState<SubjectApi>(new SubjectApi(getApiUrl()));
  const [subjectOptions, setSubjectOptions] = useState<IDropdownOption[]>([]);

  useEffect(() => {
    subjectApi.getAll().then((res) => {
      setSubjectOptions(
        (res ?? []).map((s) => ({ key: s.subjectId ?? "", text: s.name ?? "" }))
      );
    });
  }, [subjectApi]);

  return (
    <Dropdown
      {...props}
      options={subjectOptions}
      style={{ width: "100%" }}
    />
  );
}

SubjectsDropdown.defaultProps = {
  label: null,
  placeholder: null,
  required: false,
  disabled: false,
};
